module.exports = __webpack_public_path__ + "img/banner.87e5448b.png";